module.exports = __webpack_public_path__ + "img/smart_appliance_power.36f0791a.png";